module.exports = "pegasus/assets/test-fixture-car-front.jpg";